import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import Script from 'next/script';

const Banner = dynamic(() => import('../../Banner'), {
  ssr: false
});

const AdManagerBanner = dynamic(() => import('../../Banner/AdManagerBanner'), {
  ssr: false
});

const Layout = memo(
  ({
    header,
    children,
    classNames,
    contentClassNames,
    footer,
    isCurrentItem,
    currentItem
  }) => {
    const itemClasses = cn('layout', classNames);
    const contentClasses = cn(
      'layout__content',
      { layout__space: isCurrentItem },
      contentClassNames
    );

    return (
      <div className={itemClasses}>
        <Script src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" />

        {currentItem && (
          <>
            <Banner
              key="lotriver-top-banner"
              containerClassName={'lotriver-top-banner'}
              containerId={'js-lotriver-top-banner'}
              sid={'220686'}
              bn={'2'}
              arCn={1}
              target={currentItem}
            />

            <AdManagerBanner bannerName={'top'} />
          </>
        )}
        {header}
        <div className={contentClasses}>{children}</div>
        {footer}
      </div>
    );
  }
);

Layout.displayName = `Layout`;

Layout.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  classNames: PropTypes.string,
  currentItem: PropTypes.object,
  isCurrentItem: PropTypes.bool,
  contentClassNames: PropTypes.string
};

export default Layout;
